import { render, staticRenderFns } from "./manage-booking-order-details.vue?vue&type=template&id=8fb4dff2&scoped=true"
import script from "./manage-booking-order-details.vue?vue&type=script&lang=ts"
export * from "./manage-booking-order-details.vue?vue&type=script&lang=ts"
import style0 from "./manage-booking-order-details.vue?vue&type=style&index=0&id=8fb4dff2&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb4dff2",
  null
  
)

export default component.exports